// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { MathUtils } from "../MathUtils.js";
import { Resources } from "../../Commons/properties/Resources.js";

export class VolumeFormatter
{
    static GetVolumeFormat (volume, IsAbbreviateVolumes = false)
    {
        if (volume === null || isNaN(volume))
            return Resources.getResource("general.N_A");

        if (IsAbbreviateVolumes)
        {
            let abbreviate = "";
            if (Math.abs(volume) >= 1000000000000)
            {
                volume /= 1000000000000;
                abbreviate = "T";
            }
            else if (Math.abs(volume) >= 1000000000)
            {
                volume /= 1000000000;
                abbreviate = "B";
            }
            else if (Math.abs(volume) >= 1000000)
            {
                volume /= 1000000;
                abbreviate = "M";
            }
            else if (Math.abs(volume) >= 1000)
            {
                volume /= 1000;
                abbreviate = "K";
            }

            if (abbreviate)
                return `${MathUtils.TruncateDouble(volume, 1)}${abbreviate}`;
        }

        return volume.toString();
    }
}